import { render, staticRenderFns } from "./RepairsPendingIssueList.vue?vue&type=template&id=bc814db0&scoped=true&"
import script from "./RepairsPendingIssueList.vue?vue&type=script&lang=js&"
export * from "./RepairsPendingIssueList.vue?vue&type=script&lang=js&"
import style0 from "./RepairsPendingIssueList.vue?vue&type=style&index=0&id=bc814db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc814db0",
  null
  
)

export default component.exports